/** ru-RU display labels + option lists for loyalty enums. */
import type {
  BonusAccountStatus,
  BonusTransactionType,
  CardPoolStatus,
  GenerateMode,
  LoyaltyCardStatus,
  LoyaltyCardType,
  LoyaltyProgramModel,
  LoyaltyRuleType,
  ReservationStatus,
} from './types';

export const BONUS_STATUS_LABELS: Record<BonusAccountStatus, string> = {
  ACTIVE: 'Активен',
  BLOCKED: 'Заблокирован',
  CLOSED: 'Закрыт',
};

export const CARD_STATUS_LABELS: Record<LoyaltyCardStatus, string> = {
  ACTIVE: 'Активна',
  BLOCKED: 'Заблокирована',
  EXPIRED: 'Истекла',
};

export const CARD_TYPE_LABELS: Record<LoyaltyCardType, string> = {
  PHYSICAL: 'Физическая',
  VIRTUAL: 'Виртуальная',
};

export const TX_TYPE_LABELS: Record<BonusTransactionType, string> = {
  ACCRUAL: 'Начисление',
  REDEMPTION: 'Списание',
  ADJUSTMENT: 'Корректировка',
  EXPIRATION: 'Сгорание',
};

export const RULE_TYPE_LABELS: Record<LoyaltyRuleType, string> = {
  ACCRUAL: 'Начисление',
  REDEMPTION: 'Списание',
  TIER_ASSIGNMENT: 'Назначение уровня',
};

export const CARD_POOL_STATUS_LABELS: Record<CardPoolStatus, string> = {
  AVAILABLE: 'Свободна',
  ISSUED: 'Выдана',
};

export const PROGRAM_MODEL_LABELS: Record<LoyaltyProgramModel, string> = {
  BONUS: 'Бонусы',
  DISCOUNT: 'Скидка',
  NONE: 'Выключена',
};

export const GENERATE_MODE_LABELS: Record<GenerateMode, string> = {
  RANGE: 'Диапазон',
  MASK: 'Маска',
};

export const RESERVATION_STATUS_LABELS: Record<ReservationStatus, string> = {
  RESERVED: 'Удержан',
  CONFIRMED: 'Списан',
  RELEASED: 'Возвращён',
};

export const CARD_TYPE_OPTIONS: LoyaltyCardType[] = ['PHYSICAL', 'VIRTUAL'];
export const RULE_TYPE_OPTIONS: LoyaltyRuleType[] = ['ACCRUAL', 'REDEMPTION', 'TIER_ASSIGNMENT'];
export const PROGRAM_MODEL_OPTIONS: LoyaltyProgramModel[] = ['BONUS', 'DISCOUNT', 'NONE'];
export const GENERATE_MODE_OPTIONS: GenerateMode[] = ['RANGE', 'MASK'];
export const CARD_POOL_STATUS_OPTIONS: CardPoolStatus[] = ['AVAILABLE', 'ISSUED'];
